import type { ZervantTemplateSettings } from '../../../types/templates/zervantTemplateSettings'
import { getCustomTemplateSettingsPayload } from '../../../utils/getCustomTemplateSettingsPayload'
import { getLogoAndBrandingSettingsDefaultValues } from './getLogoAndBrandingSettingsDefaultValues'
import { getLogoAndBrandingTemplateFormValues } from './getLogoAndBrandingTemplateFormValues'

// The saved template as the form reads it. An organization without a template sees the form defaults,
// so the preview and the preview patch compare against the same values.
export const getLogoAndBrandingSavedTemplateSettings = (
  documentTemplateSettings?: ZervantTemplateSettings,
): ZervantTemplateSettings => {
  const { areas, color, font } = getCustomTemplateSettingsPayload(
    getLogoAndBrandingSettingsDefaultValues(getLogoAndBrandingTemplateFormValues(documentTemplateSettings)),
  )

  return { ...documentTemplateSettings, areas, color, font }
}
